export default {
  
  'purchasingGrouping.form.company': 'Empresa',
  'purchasingGrouping.form.supplier': 'Fornecedor',
  'purchasingGrouping.form.documentType': 'Tipo de Documento',
  
  'purchasingGrouping.form.table.purchasesToBeGrouped': 'Compras a Agrupar',
  'purchasingGrouping.form.table.code': 'Código',
  'purchasingGrouping.form.table.documentNumber': 'Número do Documento',
  'purchasingGrouping.form.table.issuanceDate': 'Data de emissão',
  'purchasingGrouping.form.table.releaseDateOf': 'Data de Lançamento',
  'purchasingGrouping.form.table.departureDate': 'Data de saída',
  'purchasingGrouping.form.table.amount': 'Valor Total',


  'purchasingGrouping.form.button.generateCluster': 'Gerar Agrupamento',
  'purchasingGrouping.form.button.searchForPurchases': 'Buscar Compras',

};
